import React, { Component } from "react";
import { Formik, Form } from "formik";
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../apiService";
import Autocomplete from "react-autocomplete";

// const SignupSchema = Yup.object().shape({
//   name: Yup.string().required("Nama harus diisi"),
//   username: Yup.string().required("Nama pengguna harus diisi"),
//   password: Yup.string().required("Password tidak boleh kosong"),
//   confirmedPassword: Yup.string()
//     .required("Password is required")
//     .oneOf([Yup.ref("password"), null], "Passwords must match")
// });

export default class modalAddresep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visit_id: "",
      drugsData: [],
      refSigna: [],
      drugs: [
        {
          visit_id: "",
          visit_inpatient_detail_id: 0,
          combination_name: "",
          combination_qty: 0,
          signa_id: 1,
          signa_1: "3",
          signa_2: "1",
          signa_3: "Bungkus",
          signa_4: "Sehari",
          name: "",
          log: 0,
          note: "",
          details: [
            {
              drug_in_detail_id: null,
              qty: "0",
              drug: {
                id: "",
                name: "",
              },
              drug_id: "",
            },
          ],
        },
      ],

      drugsMix: [
        {
          visit_id: "",
          visit_inpatient_detail_id: 0,
          combination_name: "",
          combination_qty: 0,
          signa_id: 1,
          signa_1: "3",
          signa_2: "1",
          signa_3: "Bungkus",
          signa_4: "Sehari",
          name: "",
          log: 0,
          note: "",
          details: [
            {
              drug_in_detail_id: null,
              qty: "0",
              drug: {
                id: "",
                drug: { name: "" },
              },
              drug_id: "",
            },
          ],
        },
      ],
    };
    this.timeout = 0;
  }
  componentDidUpdate(prevProps) {
    if (prevProps.drugs !== this.props.drugs || prevProps.drugsmix !== this.props.drugsmix) {
      this.setState({
        drugs: this.props.drugs,
        drugsMix: this.props.drugsmix
      });
    }
  }
  componentDidMount() {
    this.getSigna();
  }
  handleAddInput = (x) => (evt) => {
    this.setState({
      [evt.target.name]: x,
    });
  };
  // onChangeDrugs = (idx) => (evt) => {
  //   // console.log(evt.target.value);
  //   const newDrugs = this.state.drugs.map((tr, sidx) => {
  //     if (idx !== sidx) return tr;
  //     return {
  //       visit_id: "",
  //       visit_inpatient_detail_id: 0,
  //       combination_name: "",
  //       combination_qty: 0,
  //       signa_id: 1,
  //       log: 0,
  //       // name: evt.target.value,
  //       details: [
  //         {
  //           drug_in_detail_id: null,
  //           qty: "",
  //           drug: {
  //             id: "",
  //             name: evt.target.value,
  //           },
  //           drug_id: "",
  //         },
  //       ],
  //     };
  //   });

  //   this.setState({ drugs: newDrugs });

  //   const par = evt.target.value;
  //   // if (evt.target.value.length > 2) {
  //   //   this.retrieveDataAsynchronouslyDrugs(par);
  //   // }
  //   if (this.timeout) clearTimeout(this.timeout);
  //   this.timeout = setTimeout(() => {
  //     //search function
  //     this.retrieveDataAsynchronouslyDrugs(par);
  //   }, 500);
  // };
  onChangeDrugs = (idx) => (evt) => {
    // console.log(evt.target.value);
    const newDrugs = this.state.drugs.map((tr, sidx) => {
      if (idx !== sidx) return tr;
      return {
        visit_id: "",
        visit_inpatient_detail_id: 0,
        combination_name: "",
        combination_qty: 0,
        signa_id: 1,
        signa_1: "3",
        signa_2: "1",
        signa_3: "Bungkus",
        signa_4: "Sehari",
        log: 0,
        // name: evt.target.value,
        details: [
          {
            drug_in_detail_id: null,
            qty: "0",
            drug: {
              id: "",
              name: evt.target.value,
            },
            drug_id: "",
          },
        ],
      };
    });

    this.setState({ drugs: newDrugs });

    const par = evt.target.value;
    // if (evt.target.value.length > 2) {
    //   this.retrieveDataAsynchronouslyDrugs(par);
    // }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.retrieveDataAsynchronouslyDrugs(par);
    }, 500);
  };

  getSigna = async (e) => {
    const res = await API.get("management/signa/read");
    if (res.code === 200) {
      this.setState({
        refSigna: res.data,
      });
    }
  };
  retrieveDataAsynchronouslyDrugs = async (e) => {
    let clinicQuery = '&clinic_id=' + this.props.patient.clinics.drug_clinic_id;
    const res = await API.get("drug/stock/read?keyword=" + e + clinicQuery);
    if (res.code === 200) {
      this.setState({
        drugsData: res.data.filter(
          (dat) =>
            dat.user_approval_id !== null &&
            dat.stock_in.qty - dat.stock_out.qty > 0
        ),
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };
  /**
   * Callback triggered when the autocomplete input changes.
   *
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
  onSelect(val) {
    this.setState({
      value: val,
    });
    const x = val.split("-", 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */

  getItemValueDrugs(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.drug_id}-${item.drug.name}-${item.id}`;
  }

  changeQty = (idx) => (evt) => {
    const val = evt.target.value;

    const drugs = [...this.state.drugs];
    drugs[idx].details[0].qty = val;
    this.setState({ drugs });
    //  console.log(dr);
  };

  changeSigna = (idx) => (evt) => {
    const val = evt.target.value;

    const drugs = [...this.state.drugs];
    drugs[idx].signa_id = val;
    this.setState({ drugs });
    //  console.log(dr);
  };
  changeCatatan = (idx) => (evt) => {
    const val = evt.target.value;

    const drugs = [...this.state.drugs];
    drugs[idx].note = val;
    this.setState({ drugs });
    //  console.log(dr);
  };
  handleInputNameChangeDrugs = (idx) => (evt) => {
    const val = evt.split("-", 3);
    const newDrugs = this.state.drugs.map((dr, sidx) => {
      if (idx !== sidx) return dr;
      return {
        visit_id: this.props.patient.id,
        visit_inpatient_detail_id: 0,
        combination_name: "",
        combination_qty: 0,
        signa_id: 1,
        signa_1: "3",
        signa_2: "1",
        signa_3: "Bungkus",
        signa_4: "Sehari",
        log: 0,
        note: "",
        details: [
          {
            drug_in_detail_id: val[2],
            qty: 0,
            drug: {
              id: val[0],
              name: val[1],
            },
            drug_id: val[0],
          },
        ],
      };
    });

    this.setState({ drugs: newDrugs });
    setTimeout(
      function () {
        let parent = [];
        parent = { data: this.state.drugs, param: "prescribes" };
        this.props.parentCallback(parent);
      }.bind(this),
      200
    );
  };

  handleRemoveInputObat = (idx) => (evt) => {
    const drugs = [...this.state.drugs];
    drugs[idx].log = 1;
    if (drugs[idx].visit_id !== "") {
      this.setState({ drugs });
    } else {
      this.setState({
        [evt.target.name]: this.state.drugs.filter((s, sidx) => idx !== sidx),
      });
    }
  };

  postObat = async (e) => {
    let prescribe = this.state.drugs;
    let res = await API.put(`/registration/prescribe/update`, { prescribe });
    if (res.code === 200) {
      this.setState({ drugs: res.data });
    } else {
    }
  };

  //obat end

  // drug mix
  postObatMix = async (e) => {
    let prescribe = this.state.drugsMix;
    console.log(prescribe)
    let res = await API.put(`/registration/prescribe/update`, { prescribe });
    if (res.code === 200) {
      this.setState({ drugs: res.data });
    } else {
    }
  };
  addDrugsMix = (idx) => (e) => {
    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details = drugsMix[idx].details.concat([
      {
        drug_in_detail_id: null,
        qty: 10,
        drug: {
          id: "",
          name: "",
        },
        drug_id: "",
      },
    ]);
    this.setState({ drugsMix });
  };
  handleInputNameChangeDrugsMix = (idx, y) => (evt) => {
    let val = evt.split("-", 3);
    // console.log(evt, val);
    let drugsMix = [...this.state.drugsMix];
    drugsMix[idx].visit_id = this.props.patient.id;
    drugsMix[idx].details[y].drug.name = val[1];
    drugsMix[idx].details[y].drug_id = val[0];
    drugsMix[idx].details[y].drug.id = val[0];
    drugsMix[idx].details[y].drug_in_detail_id = val[2];

    this.setState({ drugsMix });
  };

  handleRemoveInputObatMix = (idx) => (evt) => {
    this.setState({
      [evt.target.name]: this.state.drugsMix.filter((s, sidx) => idx !== sidx),
    });
  };
  handleRemoveDrugsMixDetail = (idx, y) => (e) => {
    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details = drugsMix[idx].details.filter(
      (s, sidx) => y !== sidx
    );
    this.setState({ drugsMix });
  };
  onChangeDrugsMix = (idx, y) => (evt) => {
    // console.log(idx, y, evt.target.value);
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details[y].drug.name = val;
    this.setState({ drugsMix });

    const par = evt.target.value;
    // if (evt.target.value.length > 2) {
    //   this.retrieveDataAsynchronouslyDrugs(par);
    // }
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.retrieveDataAsynchronouslyDrugs(par);
    }, 500);
  };
  changeSignaMix = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].signa_id = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeQtyMix = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].combination_qty = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeQtyMixDetail = (idx, y) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].details[y].qty = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeCombinationName = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].combination_name = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  changeCatatanMix = (idx) => (evt) => {
    const val = evt.target.value;

    const drugsMix = [...this.state.drugsMix];
    drugsMix[idx].note = val;
    this.setState({ drugsMix });
    //  console.log(dr);
  };

  handleSubmit() {
    this.postObat();
    this.postObatMix();
    this.props.onHide();
  }
  //drug mix end
  render() {
    // console.log(this.state);
    let refSigna = this.state.refSigna.map((sig, idx) => {
      return (
        <option key={idx} value={sig.id}>
          {sig.name}
        </option>
      );
    });

    return (
      <Modal size="lg" {...this.props} aria-labelledby='modal-user'>
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Tambah Resep</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            drug: this.state.drugs,
            drugsMix: this.state.drugsMix,
          }}
          //   validationSchema={SignupSchema}
          onSubmit={(values) => {
            // same shape as initial values
            // console.log(values);
            this.handleSubmit();
          }}>
          {({ values, errors, touched }) => (
            <Form>
              <ModalBody>
                <div className='form-group row'>
                  <div className='col-md-3'>
                    <label
                      className='col-form-label col-form-label-sm'>
                      Obat
                    </label>
                  </div>
                  <div className='col-md-9'>
                    {this.state.drugs.map((drugs, idx) => {
                      if (!drugs.log)
                        return (
                          <div key={idx} className='form-group mb-2'>
                            <div className='row'>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 mb-1'>
                                    <Autocomplete
                                      inputProps={{
                                        className: "form-control form-control-sm",
                                        placeholder: "ketikkan minimal 3 huruf obat",
                                      }}
                                      items={this.state.drugsData}
                                      getItemValue={this.getItemValueDrugs}
                                      renderItem={(item, highlighted) => (
                                        <div
                                          key={item.id}
                                          className="p-1"
                                          style={{
                                            backgroundColor: highlighted
                                              ? "#eee"
                                              : "transparent",
                                          }}>
                                          <div>
                                            {item.id} - {item.drug.name}
                                          </div>
                                          <div className='d-flex justify-content-between'>
                                            <span style={{ color: "#5e72e4" }}>
                                              Stok: <b>{item.stock_in.qty - item.stock_out.qty}</b>
                                            </span>
                                            <span style={{ color: "#f5365c" }}>
                                              Ed: <b>{moment(item.expired_date).format('DD-MM-YYYY')}</b>
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                      value={
                                        this.state.drugs[idx].details[0]
                                          ? this.state.drugs[idx].details[0].drug.name
                                          : ""
                                      }
                                      onChange={this.onChangeDrugs(idx)}
                                      onSelect={this.handleInputNameChangeDrugs(idx)}
                                      menuStyle={{
                                        borderRadius: "3px",
                                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                        background: "rgba(255, 255, 255, 0.9)",
                                        padding: "2px 0",
                                        fontSize: "90%",
                                        // position: "fixed",
                                        overflow: "auto",
                                        zIndex: "100",
                                        maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                                      }}
                                      wrapperStyle={{
                                        maxWidth: "100%",
                                        flex: "0 0 100%",
                                        overflow: "auto",
                                        maxHeight: '300px'
                                      }}
                                    />
                                  </div>
                                  {/* <div className='col-md-8 mb-1 pr-md-0'>
                                    <select
                                      className='form-control form-control-sm'
                                      name='signa'
                                      dat={idx}
                                      onChange={this.changeSigna(idx)}
                                      value={drugs.signa_id}>
                                      {refSigna}
                                    </select>
                                  </div>
                                  <div className='col-md-4 mb-1 pl-md-0'>
                                    <input
                                      className='form-control form-control-sm'
                                      type='text'
                                      placeholder='jumlah'
                                      name='Qty'
                                      onChange={this.changeQty(idx)}
                                      value={
                                        drugs.details[0] ? drugs.details[0].qty : ""
                                      }
                                    />
                                  </div> */}
                                  <div className="row">
                                    <div className={'col-md-8 px-0'} style={{ display: 'flex', alignItems: 'center' }}>
                                      <input
                                        className="form-control form-control-sm"
                                        style={{ flex: 1 }}
                                        type="number"
                                        onChange={e => {
                                          let drugs = [...this.state.drugs]
                                          drugs[idx].signa_1 = e.target.value
                                          this.setState({ drugs })
                                        }}
                                        value={drugs.signa_1}
                                      />
                                      <span className={'mx-1'}>x</span>
                                      <input
                                        className="form-control form-control-sm"
                                        style={{ flex: 1 }}
                                        type="number"
                                        onChange={e => {
                                          let drugs = [...this.state.drugs]
                                          drugs[idx].signa_2 = e.target.value
                                          this.setState({ drugs })
                                        }}
                                        value={drugs.signa_2}
                                      />
                                      <input
                                        className="form-control form-control-sm"
                                        style={{ flex: 2 }}
                                        type="text"
                                        onChange={e => {
                                          let drugs = [...this.state.drugs]
                                          drugs[idx].signa_3 = e.target.value
                                          this.setState({ drugs })
                                        }}
                                        value={drugs.signa_3}
                                      />
                                      <input
                                        className="form-control form-control-sm"
                                        style={{ flex: 2 }}
                                        type="text"
                                        onChange={e => {
                                          let drugs = [...this.state.drugs]
                                          drugs[idx].signa_4 = e.target.value
                                          this.setState({ drugs })
                                        }}
                                        value={drugs.signa_4}
                                      />
                                      <div className={'mx-2'} />
                                    </div>
                                    {/*<select*/}
                                    {/*  className="form-control form-control-sm col-md-6"*/}
                                    {/*  name="signa"*/}
                                    {/*  dat={idx}*/}
                                    {/*  onChange={this.changeSigna(idx)}*/}
                                    {/*  value={drugs.signa_id}*/}
                                    {/*>*/}
                                    {/*  {refSigna}*/}
                                    {/*</select>*/}

                                    <input
                                      className="form-control form-control-sm col-md-4 px-0 pl-2"
                                      type="text"
                                      placeholder="jumlah"
                                      name="Qty"
                                      onChange={this.changeQty(idx)}
                                      value={
                                        drugs.details[0] ? drugs.details[0].qty : ""
                                      }
                                    />
                                    <input
                                      className='form-control form-control-sm col-12'
                                      type='text'
                                      placeholder='catatan'
                                      name='note'
                                      onChange={this.changeCatatan(idx)}
                                      value={drugs ? drugs.note : ""}
                                    />
                                  </div>
                                  {/* <div className='col-12'>
                                    <input
                                      className='form-control form-control-sm'
                                      type='text'
                                      placeholder='catatan'
                                      name='note'
                                      onChange={this.changeCatatan(idx)}
                                      value={drugs ? drugs.note : ""}
                                    />
                                  </div> */}
                                </div>
                              </div>
                              <div className='col-2 pl-0'>
                                <button
                                  className='btn btn-block btn-sm btn-danger'
                                  name='drugs'
                                  onClick={this.handleRemoveInputObat(idx)}>
                                  -
                                </button>
                              </div>
                            </div>
                            <hr className="m-0 mt-3 rounded bg-secondary p-0" />
                          </div>
                        );
                    })}
                    <button
                      type='button'
                      name='drugs'
                      onClick={this.handleAddInput(
                        this.state.drugs.concat([
                          {
                            visit_id: "",
                            visit_inpatient_detail_id: 0,
                            combination_name: "",
                            combination_qty: 0,
                            signa_id: 1,
                            signa_1: "3",
                            signa_2: "1",
                            signa_3: "Bungkus",
                            signa_4: "Sehari",
                            log: 0,
                            note: "",
                            details: [
                              {
                                drug_in_detail_id: null,
                                qty: "0",
                                drug: {
                                  id: "",
                                  name: "",
                                },
                              },
                            ],
                          },
                        ])
                      )}
                      className='btn btn-sm btn-primary btn-block'>
                      Tambah Obat
                    </button>
                  </div>
                </div>
                <div className='form-group row'>
                  <div className='col-md-3'>
                    <label
                      htmlFor='example-text-input'
                      className=' col-form-label col-form-label-sm'>
                      Obat Racikan
                    </label>
                  </div>
                  <div className='col-md-9'>
                    {this.state.drugsMix.map((drugsMix, idx) => {
                      if (!drugsMix.log)
                        return (
                          <div key={idx} className='form-group mb-2'>
                            <div className='row'>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 mb-1'>
                                    <input
                                      className='form-control form-control-sm'
                                      type='text'
                                      placeholder='Nama Obat Racikan'
                                      id='example-text-input'
                                      name='head'
                                      onChange={this.changeCombinationName(idx)}
                                      value={
                                        this.state.drugsMix[idx].combination_name
                                      }
                                    />
                                  </div>
                                  <div className={'col-md-12'}>
                                    <div className={'row'}>
                                      <div className={'col-md-8 px-0'} style={{ display: 'flex', alignItems: 'center' }}>
                                        <input
                                          className="form-control form-control-sm"
                                          style={{ flex: 1 }}
                                          type="number"
                                          onChange={e => {
                                            let drugsMix = [...this.state.drugsMix]
                                            drugsMix[idx].signa_1 = e.target.value
                                            this.setState({ drugsMix })
                                          }}
                                          value={drugsMix.signa_1}
                                        />
                                        <span className={'mx-1'}>x</span>
                                        <input
                                          className="form-control form-control-sm"
                                          style={{ flex: 1 }}
                                          type="number"
                                          onChange={e => {
                                            let drugsMix = [...this.state.drugsMix]
                                            drugsMix[idx].signa_2 = e.target.value
                                            this.setState({ drugsMix })
                                          }}
                                          value={drugsMix.signa_2}
                                        />
                                        <input
                                          className="form-control form-control-sm"
                                          style={{ flex: 2 }}
                                          type="text"
                                          onChange={e => {
                                            let drugsMix = [...this.state.drugsMix]
                                            drugsMix[idx].signa_3 = e.target.value
                                            this.setState({ drugsMix })
                                          }}
                                          value={drugsMix.signa_3}
                                        />
                                        <input
                                          className="form-control form-control-sm"
                                          style={{ flex: 2 }}
                                          type="text"
                                          onChange={e => {
                                            let drugsMix = [...this.state.drugsMix]
                                            drugsMix[idx].signa_4 = e.target.value
                                            this.setState({ drugsMix })
                                          }}
                                          value={drugsMix.signa_4}
                                        />
                                        <div className={'mx-2'} />
                                      </div>
                                      <input
                                        className="form-control form-control-sm col-md-4"
                                        type="text"
                                        placeholder="jumlah"
                                        name="Qty"
                                        onChange={this.changeQtyMix(idx)}
                                        value={this.state.drugsMix[idx].combination_qty}
                                      />
                                    </div>
                                  </div>
                                  <div className='col-12'>
                                    <input
                                      className='form-control form-control-sm'
                                      type='text'
                                      placeholder='catatan'
                                      name='note'
                                      onChange={this.changeCatatanMix(idx)}
                                      value={
                                        this.state.drugsMix[idx]
                                          ? this.state.drugsMix[idx].note
                                          : ""
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='col-2 pl-0'>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-danger btn-block'
                                  name='drugsMix'
                                  onClick={this.handleRemoveInputObatMix(idx)}>
                                  -
                                </button>
                              </div>
                              <div className='col-12'>
                                <div className='bg-secondary rounded p-2 mt-2 border'>
                                  <div className='row'>
                                    {drugsMix.details.map((x, y) => {
                                      return (
                                        <div key={y} className='col-12 mb-1'>
                                          <div className='row'>
                                            <div className='col-8 pr-0'>
                                              <Autocomplete
                                                inputProps={{
                                                  className: "form-control form-control-sm",
                                                  placeholder:
                                                    "ketikkan minimal 3 huruf obat",
                                                }}
                                                items={this.state.drugsData}
                                                getItemValue={this.getItemValueDrugs}
                                                renderItem={(item, highlighted) => (
                                                  <div
                                                    key={item.id}
                                                    className="p-1"
                                                    style={{
                                                      backgroundColor: highlighted
                                                        ? "#eee"
                                                        : "transparent",
                                                    }}>
                                                    <div>
                                                      {item.id} - {item.drug.name}
                                                    </div>
                                                    <div className='d-flex justify-content-between'>
                                                      <span style={{ color: "#5e72e4" }}>
                                                        Stok: <b>{item.stock_in.qty - item.stock_out.qty}</b>
                                                      </span>
                                                      <span style={{ color: "#f5365c" }}>
                                                        Ed: <b>{moment(item.expired_date).format('DD-MM-YYYY')}</b>
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                                value={
                                                  this.state.drugsMix[idx].details[y].drug
                                                    .name
                                                }
                                                onChange={this.onChangeDrugsMix(idx, y)}
                                                onSelect={this.handleInputNameChangeDrugsMix(
                                                  idx,
                                                  y
                                                )}
                                                menuStyle={{
                                                  borderRadius: "3px",
                                                  boxShadow:
                                                    "0 2px 12px rgba(0, 0, 0, 0.1)",
                                                  background: "rgba(255, 255, 255, 0.9)",
                                                  padding: "2px 0",
                                                  fontSize: "90%",
                                                  // position: "fixed",
                                                  overflow: "auto",
                                                  zIndex: "100",
                                                  maxHeight: "110%", // TODO: don't cheat, let it flow to the bottom
                                                }}
                                                wrapperStyle={{
                                                  maxWidth: "100%",
                                                  flex: "0 0 100%",
                                                  overflow: "auto",
                                                  maxHeight: '300px'
                                                }}
                                              />
                                            </div>
                                            <div className='col-2 p-0'>
                                              <input
                                                className='form-control form-control-sm'
                                                type='text'
                                                placeholder='jumlah'
                                                name='Qty'
                                                onChange={this.changeQtyMixDetail(idx, y)}
                                                value={
                                                  this.state.drugsMix[idx].details[y].qty
                                                }
                                              />
                                            </div>
                                            <div className='col text-right'>
                                              <button
                                                type='button'
                                                className='btn btn-sm btn-outline-danger btn-block'
                                                name='drugs'
                                                onClick={this.handleRemoveDrugsMixDetail(
                                                  idx,
                                                  y
                                                )}>
                                                -
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <button
                                    type='button'
                                    className='btn btn-sm btn-outline-default btn-block mt-2'
                                    name='drugsMix'
                                    onClick={this.addDrugsMix(idx)}>
                                    Tambah Obat Resep
                                  </button>
                                </div>
                              </div>
                            </div>
                            <hr className="m-0 mt-3 rounded bg-secondary p-0" />
                          </div>
                        );
                    })}
                    <button
                      type='button'
                      name='drugsMix'
                      onClick={this.handleAddInput(
                        this.state.drugsMix.concat([
                          {
                            visit_id: "",
                            visit_inpatient_detail_id: 0,
                            combination_name: "",
                            combination_qty: 0,
                            signa_id: 1,
                            signa_1: "3",
                            signa_2: "1",
                            signa_3: "Bungkus",
                            signa_4: "Sehari",
                            note: "",
                            log: false,
                            details: [
                              {
                                drug_in_detail_id: null,
                                qty: "0",
                                drug: {
                                  id: "",
                                  name: "",
                                },
                              },
                            ],
                          },
                        ])
                      )}
                      className='btn btn-sm btn-primary btn-block'>
                      Tambah Resep
                    </button>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <div className='row'>
                  <div className='col-12'>
                    <button
                      type='button'
                      onClick={this.props.onHide}
                      className='btn btn-outline-secondary'>
                      Batal
                    </button>
                    <button type='submit' className='btn btn-primary'>
                      Submit
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
